export default __webpack_public_path__ + "static/media/send_bg.0919f59f.png";